module.exports = __webpack_public_path__ + "media/images/icons/miss-default-320f0d3d97fbede842601c422cf1ede3.png";